/* Open chat on click on link with #chat anchor in URL */
document.addEventListener('click', (e) => {
  if (!e.target) return;

  if (e.target.hasAttribute('href') && e.target.getAttribute('href').includes('#chat')) {
    e.preventDefault();
    const chatElement = document?.getElementById(`ShopifyChat`)?.shadowRoot?.querySelector(`.chat-app>button`)
    chatElement && chatElement.click()
  }
});
/* END Open chat on click on link with #chat anchor in URL */


/* RESTORE DISCOUNT CODES AFTER CHECKOUT RETURN */
document.addEventListener('DOMContentLoaded', () => {
  const tempDiscountCodes = sessionStorage.getItem('tempDiscountCodes');
  if (!tempDiscountCodes) return;

  const cartDataElement = document.getElementById('cart-data');
  if (!cartDataElement) return;
  
  const currentCartData = cartDataElement.textContent;
  if (!currentCartData) return;

  const savedCartData = sessionStorage.getItem('tempCartData');
  
  if (savedCartData === currentCartData) {
    localStorage.setItem('discountCodes', tempDiscountCodes);
  }
  
  sessionStorage.removeItem('tempDiscountCodes');
  sessionStorage.removeItem('tempCartData');
});
/* END RESTORE DISCOUNT CODES AFTER CHECKOUT RETURN */


/* MEGAMENU CARDS HOVER */
document.addEventListener('DOMContentLoaded', () => {
  // Restore default content from data attributes
  const restoreDefaults = (megaMenu) => {
    const imageElement = megaMenu.querySelector('.mega-menu__parent-card-image');
    const titleElement = megaMenu.querySelector('.mega-menu__parent-card-title');
    const textElement = megaMenu.querySelector('.mega-menu__parent-card-text');
    const buttonElement = megaMenu.querySelector('.mega-menu__parent-card .button');
    const allLinks = megaMenu.querySelectorAll('.mega-menu__parent-card a');
    
    // Read default values from data attributes
    if (imageElement) {
      const defaultImg = imageElement.getAttribute('data-default-img');
      if (defaultImg) {
        imageElement.src = defaultImg;
      }
    }
    
    if (titleElement) {
      const defaultText = titleElement.getAttribute('data-default-text');
      if (defaultText) {
        titleElement.textContent = defaultText;
      }
    }
    
    if (textElement) {
      const defaultText = textElement.getAttribute('data-default-text');
      if (defaultText) {
        textElement.textContent = defaultText;
      }
    }
    
    if (buttonElement) {
      const defaultText = buttonElement.getAttribute('data-default-text');
      if (defaultText) {
        buttonElement.textContent = defaultText;
      }
    }
    
    allLinks.forEach(link => {
      const defaultLink = link.getAttribute('data-default-link');
      if (defaultLink) {
        link.href = defaultLink;
      }
    });
    
    const submenu = megaMenu.closest('.menu-list__submenu');
    if (submenu) {
      requestAnimationFrame(() => {
        const submenuInner = submenu.querySelector('.menu-list__submenu-inner');
        if (submenuInner) {
          const newHeight = submenuInner.offsetHeight;
          submenu.style.setProperty('--submenu-height', `${newHeight}px`);
        }
      });
    }
  };
  
  // Initialize hover listeners
  const initMegaMenuHover = () => {
    const menuLinks = document.querySelectorAll('[data-link-image]');
  
    menuLinks.forEach(link => {
      link.addEventListener('mouseenter', (e) => {
        const target = e.currentTarget;
        const linkImage = target.getAttribute('data-link-image');
        const linkTitle = target.getAttribute('data-link-title');
        const linkText = target.getAttribute('data-link-text');
        const linkButtonLabel = target.getAttribute('data-link-button-label');
        const linkButtonLink = target.getAttribute('data-link-button-link');
        
        const megaMenu = target.closest('.mega-menu');
        if (!megaMenu) return;
        
        const imageElement = megaMenu.querySelector('.mega-menu__parent-card-image');
        const titleElement = megaMenu.querySelector('.mega-menu__parent-card-title');
        const textElement = megaMenu.querySelector('.mega-menu__parent-card-text');
        const buttonElement = megaMenu.querySelector('.mega-menu__parent-card .button');
        const allLinks = megaMenu.querySelectorAll('.mega-menu__parent-card a');
        
        // Read defaults from data attributes
        const defaultImg = imageElement?.getAttribute('data-default-img');
        const defaultTitle = titleElement?.getAttribute('data-default-text');
        const defaultText = textElement?.getAttribute('data-default-text');
        const defaultButtonLabel = buttonElement?.getAttribute('data-default-text');
        const defaultButtonLink = buttonElement?.getAttribute('data-default-link');
        
        // Update image
        if (imageElement) {
          const newSrc = (linkImage && linkImage.trim() !== '') ? linkImage : defaultImg;
          if (newSrc) {
            const preloadImg = new Image();
            preloadImg.onload = function() {
              imageElement.src = newSrc;
              
              const submenu = megaMenu.closest('.menu-list__submenu');
              if (submenu) {
                requestAnimationFrame(() => {
                  const submenuInner = submenu.querySelector('.menu-list__submenu-inner');
                  if (submenuInner) {
                    const newHeight = submenuInner.offsetHeight;
                    submenu.style.setProperty('--submenu-height', `${newHeight}px`);
                  }
                });
              }
            };
            preloadImg.src = newSrc;
          }
        }
        
        if (titleElement) {
          titleElement.textContent = (linkTitle && linkTitle.trim() !== '') ? linkTitle : defaultTitle;
        }
        
        if (textElement) {
          textElement.textContent = (linkText && linkText.trim() !== '') ? linkText : defaultText;
        }
        
        if (buttonElement) {
          buttonElement.textContent = (linkButtonLabel && linkButtonLabel.trim() !== '') ? linkButtonLabel : defaultButtonLabel;
        }

        if (allLinks.length > 0) {
          const targetHref = (linkButtonLink && linkButtonLink.trim() !== '') ? linkButtonLink : defaultButtonLink;
          if (targetHref) {
            allLinks.forEach(linkEl => {
              linkEl.href = targetHref;
            });
          }
        }
      });
    });
  };
  
  // Initial setup
  initMegaMenuHover();
  
  // Watch for aria-expanded changes on main menu links
  const initAriaObservers = () => {
    const mainMenuLinks = document.querySelectorAll('.menu-list__link[aria-expanded]');
    mainMenuLinks.forEach(mainLink => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'aria-expanded') {
            const isExpanded = mainLink.getAttribute('aria-expanded') === 'true';
            
            if (!isExpanded) {
              const listItem = mainLink.closest('.menu-list__list-item');
              const megaMenu = listItem?.querySelector('.mega-menu');
              if (megaMenu) {
                setTimeout(() => restoreDefaults(megaMenu), 100);
              }
            }
          }
        });
      });
      
      observer.observe(mainLink, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    });
  };
  
  initAriaObservers();
  
  // Reinitialize after cart updates (which may rebuild the DOM)
  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      initMegaMenuHover();
      initAriaObservers();
    }, 100);
  });
});
/* END MEGAMENU CARDS HOVER */


/* CHANGE THE DATE TO THE NEXT DAY */
const changeNextDay = () => {
  const dateInput = document.getElementById('delivery-date');
  const timeSelect = document.getElementById('time-select');
  const deliverySelector = document.querySelector('delivery-selector');
  const searchPage = document.querySelector('body.template-search');

  if (dateInput && deliverySelector && !searchPage) {
    const currentTime = timeSelect ? timeSelect.value : '';
    
    // Calculate next date
    const currentDate = new Date(dateInput.value);
    currentDate.setDate(currentDate.getDate() + 1);
    
    // Use datepicker if available
    if (deliverySelector.datepicker) {
      deliverySelector.datepicker.selectDate(currentDate);
    } else {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = monthNames[currentDate.getMonth()];
      const year = currentDate.getFullYear();
      const newDateStr = `${day} ${month} ${year}`;
      
      dateInput.value = newDateStr;
      dateInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Wait for time options to regenerate, then try to select the same time if one was previously selected
    setTimeout(() => {
      if (timeSelect && currentTime && deliverySelector.timeSlimSelect) {
        const options = deliverySelector.timeSlimSelect.getData();
        const timeExists = options.some(opt => opt.value === currentTime);
        
        if (timeExists) {
          deliverySelector.timeSlimSelect.setSelected(currentTime);
          deliverySelector.formState.time = currentTime;
          timeSelect.value = currentTime;
          timeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }, 150);
  } else if (!dateInput || searchPage) {
    const deliveryType = localStorage.getItem('delivery-ship-type');
    localStorage.setItem('change-next-day', 'true');
    
    if (deliveryType === 'nationwide') {
      window.location.href = '/pages/ship-nationwide';
    } else {
      window.location.href = '/pages/local-orders';
    }
  }
};

document.addEventListener('click', (e) => {
  if (!e.target) return;

  if (e.target.classList.contains('js-choose-next-date')) {
    e.preventDefault();
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    changeNextDay();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const shouldChangeNextDay = localStorage.getItem('change-next-day');

  if (shouldChangeNextDay === 'true') {
    localStorage.removeItem('change-next-day');
    changeNextDay();
  }
});
/* END CHANGE THE DATE TO THE NEXT DAY */